module.exports = __webpack_public_path__ + "static/assets/d8bbac24c68e3a96e3f9f8ec65f44fe8.svg";